import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { INTEGRATION_KEY } from "../../state/integration/Constants"

export const formatInteger = (value) => {
    let inputValue = value.trim()
    inputValue = inputValue.replace(/[^-0-9]/g, "")

    if (/^-/.test(inputValue)) {
        inputValue = "-" + inputValue.replace(/-/g, "")
    } else {
        inputValue = inputValue.replace(/-/g, "")
    }
    return inputValue
}

export const getNylasVersion = () => {
    let nylasKey = INTEGRATION_KEY.NYLAS
    if(AppContext.getAccount().attributes.flags["enableNylasV3"]){
        nylasKey = INTEGRATION_KEY.NYLASV3
    }
    return nylasKey
}



// WEBPACK FOOTER //
// ./src/utils/common/utils.ts